/* =============================================================================
   SILO 2 — TRANSPORTE PROFESIONAL EN TARRAGONA
   -----------------------------------------------------------------------------
   Misma estructura que seguros.js. La página de categoría está escrita y
   publicada; las páginas comerciales están con el SEO preparado y publicada:
   false a la espera de contenido.
   ============================================================================= */

module.exports = {
  id: 'transporte',
  icono: 'mdi-truck-outline',

  // URL de la categoría: /transporte  y  /cat/transport
  slug: { es: 'transporte', ca: 'transport' },

  /* Etiqueta corta para menús y footer. El h1 completo no cabe en el lateral. */
  tituloMenu: { es: 'Transporte profesional', ca: 'Transport professional' },

  whatsappPropio: false,

  categoria: {
    es: {
      titleSeo: 'Transporte profesional en Tarragona | Gestoría Riola',
      description:
        'Tarjeta de transporte, capacitación, CAP y tacógrafo en Tarragona. La gestoría que conocen los transportistas de la provincia desde hace cuatro generaciones.',
      h1: 'Transporte profesional en Tarragona',
      kwPrincipal: 'gestoría de transporte Tarragona',
      kwLongTail: [
        'tarjeta de transporte Tarragona',
        'gestoría para transportistas Tarragona',
        'capacitación transportista Tarragona',
        'tramitar CAP Tarragona'
      ],

      entradilla:
        'El transporte es un sector con reglas propias, plazos que no perdonan y sanciones caras. Llevamos décadas gestionando la documentación de los transportistas de Tarragona y conocemos cada trámite por dentro.',

      secciones: [
        {
          h2: 'El problema no es hacer el trámite. Es no llegar tarde.',
          parrafos: [
            'La tarjeta de transporte se visa por periodos y la ventana para hacerlo es estrecha. El CAP caduca cada cinco años. El tacógrafo tiene sus revisiones. Y cada uno de esos plazos, si se pasa, tiene consecuencias que van desde la multa hasta no poder trabajar.',
            'Nosotros llevamos el control de los vencimientos de nuestros clientes y avisamos antes de que llegue la fecha. Es la parte del servicio que menos se ve y la que más valor tiene.'
          ],
          destacado:
            'Si nos llevas la documentación, te avisamos nosotros cuando toque renovar. No tienes que acordarte tú.'
        },
        {
          h2: 'De autónomo con un camión a empresa con flota',
          parrafos: [
            'Atendemos igual al transportista que empieza y necesita la capacitación, que a la empresa con veinte vehículos que necesita altas, bajas y visados constantes.',
            'En el segundo caso, tener un único interlocutor que conoce tu flota ahorra mucho tiempo: sabemos qué vehículos tienes, qué autorizaciones llevan y cuándo caduca cada una.'
          ]
        },
        {
          h2: 'Y también el seguro de la actividad',
          parrafos: [
            'Somos correduría de seguros además de gestoría. Eso significa que podemos cubrir la responsabilidad civil del transportista, la mercancía y la flota entera con el mismo interlocutor que te lleva las tarjetas.'
          ]
        }
      ],

      faqs: [
        {
          q: '¿Podéis llevar el visado de la tarjeta de transporte?',
          a: 'Sí, y además llevamos el control del calendario para avisarte antes de que se acabe el plazo de tu comunidad.'
        },
        {
          q: 'Estoy empezando como transportista autónomo, ¿por dónde empiezo?',
          a: 'Por la capacitación profesional y el alta de la autorización de transporte. Cuéntanos tu situación y te decimos el orden y los requisitos.'
        },
        {
          q: '¿Trabajáis con empresas de fuera de Tarragona?',
          a: 'Sí. La mayoría de trámites son telemáticos, así que la distancia no es un problema.'
        },
        {
          q: '¿Me podéis llevar también los seguros de la flota?',
          a: 'Sí, somos correduría de seguros. Es habitual que los clientes de transporte acaben llevándonos también las pólizas.'
        }
      ],

      ctaTitulo: '¿Tienes un vencimiento cerca?',
      ctaTexto: 'Dinos qué necesitas renovar y nos ocupamos antes de que se pase el plazo.',
      ctaWhatsapp: 'Hola, necesito información sobre trámites de transporte'
    },

    ca: {
      titleSeo: 'Transport professional a Tarragona | Gestoria Riola',
      description:
        'Targeta de transport, capacitació, CAP i tacògraf a Tarragona. La gestoria que coneixen els transportistes de la província des de fa quatre generacions.',
      h1: 'Transport professional a Tarragona',
      kwPrincipal: 'gestoria de transport Tarragona',
      kwLongTail: [
        'targeta de transport Tarragona',
        'gestoria per a transportistes Tarragona',
        'capacitació transportista Tarragona',
        'tramitar CAP Tarragona'
      ],

      entradilla:
        'El transport és un sector amb regles pròpies, terminis que no perdonen i sancions cares. Fa dècades que gestionem la documentació dels transportistes de Tarragona i coneixem cada tràmit per dins.',

      secciones: [
        {
          h2: 'El problema no és fer el tràmit. És no arribar tard.',
          parrafos: [
            'La targeta de transport es visa per períodes i la finestra per fer-ho és estreta. El CAP caduca cada cinc anys. El tacògraf té les seves revisions. I cadascun d\'aquests terminis, si es passa, té conseqüències que van des de la multa fins a no poder treballar.',
            'Nosaltres portem el control dels venciments dels nostres clients i avisem abans que arribi la data. És la part del servei que menys es veu i la que més valor té.'
          ],
          destacado:
            'Si ens portes la documentació, t\'avisem nosaltres quan toqui renovar. No te n\'has de recordar tu.'
        },
        {
          h2: 'D\'autònom amb un camió a empresa amb flota',
          parrafos: [
            'Atenem igual el transportista que comença i necessita la capacitació, que l\'empresa amb vint vehicles que necessita altes, baixes i visats constants.',
            'En el segon cas, tenir un únic interlocutor que coneix la teva flota estalvia molt de temps: sabem quins vehicles tens, quines autoritzacions porten i quan caduca cadascuna.'
          ]
        },
        {
          h2: 'I també l\'assegurança de l\'activitat',
          parrafos: [
            'Som corredoria d\'assegurances a més de gestoria. Això vol dir que podem cobrir la responsabilitat civil del transportista, la mercaderia i la flota sencera amb el mateix interlocutor que et porta les targetes.'
          ]
        }
      ],

      faqs: [
        {
          q: 'Podeu portar el visat de la targeta de transport?',
          a: 'Sí, i a més portem el control del calendari per avisar-te abans que s\'acabi el termini de la teva comunitat.'
        },
        {
          q: 'Estic començant com a transportista autònom, per on començo?',
          a: 'Per la capacitació professional i l\'alta de l\'autorització de transport. Explica\'ns la teva situació i et diem l\'ordre i els requisits.'
        },
        {
          q: 'Treballeu amb empreses de fora de Tarragona?',
          a: 'Sí. La majoria de tràmits són telemàtics, així que la distància no és un problema.'
        },
        {
          q: 'Em podeu portar també les assegurances de la flota?',
          a: 'Sí, som corredoria d\'assegurances. És habitual que els clients de transport acabin portant-nos també les pòlisses.'
        }
      ],

      ctaTitulo: 'Tens un venciment a prop?',
      ctaTexto: 'Digues-nos què necessites renovar i ens n\'ocupem abans que es passi el termini.',
      ctaWhatsapp: 'Hola, necessito informació sobre tràmits de transport'
    }
  },

  grupos: [
    {
      id: 'autorizaciones',
      es: { titulo: 'Autorizaciones y tarjetas', subtitulo: 'Lo que necesitas para poder trabajar' },
      ca: { titulo: 'Autoritzacions i targetes', subtitulo: 'El que necessites per poder treballar' }
    },
    {
      id: 'conductores',
      es: { titulo: 'Conductores', subtitulo: 'Formación y documentación del profesional' },
      ca: { titulo: 'Conductors', subtitulo: 'Formació i documentació del professional' }
    }
  ],

  servicios: [
    {
      slug: { es: 'tarjeta-transporte-tarragona', ca: 'targeta-transport-tarragona' },
      grupo: 'autorizaciones',
      icono: 'mdi-card-account-details-outline',
      publicada: false,
      es: {
        titleSeo: 'Tarjeta de transporte en Tarragona | Gestoría Riola',
        description:
          'Alta, visado y renovación de la tarjeta de transporte en Tarragona. Llevamos el control de tus plazos para que no se te pase el periodo de visado.',
        h1: 'Tarjeta de transporte en Tarragona',
        kwPrincipal: 'tarjeta de transporte Tarragona',
        kwLongTail: [
          'visado tarjeta de transporte Tarragona',
          'sacar tarjeta de transporte Tarragona',
          'tarjeta de transporte ligero Tarragona',
          'requisitos tarjeta de transporte MDP'
        ],
        resumen: 'Alta, visado y renovación. Y te avisamos nosotros cuando se acerque el plazo.',
        entradilla: '',
        guionH2: [
          'MDP y MDL: qué autorización te corresponde',
          'Requisitos para obtenerla',
          'El visado: cuándo toca y qué pasa si se te pasa',
          'Altas y bajas de vehículos en la autorización',
          'Nosotros llevamos el control de tus vencimientos'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['capacitacion-transportista-tarragona', 'renovacion-tarjeta-transporte-tarragona'],
        ctaTitulo: '¿Necesitas la tarjeta de transporte?',
        ctaTexto: 'Cuéntanos qué vehículos tienes y te decimos qué autorización te corresponde.',
        ctaWhatsapp: 'Hola, necesito información sobre la tarjeta de transporte'
      },
      ca: {
        titleSeo: 'Targeta de transport a Tarragona | Gestoria Riola',
        description:
          'Alta, visat i renovació de la targeta de transport a Tarragona. Portem el control dels teus terminis perquè no se\'t passi el període de visat.',
        h1: 'Targeta de transport a Tarragona',
        kwPrincipal: 'targeta de transport Tarragona',
        kwLongTail: [
          'visat targeta de transport Tarragona',
          'treure targeta de transport Tarragona',
          'targeta de transport lleuger Tarragona'
        ],
        resumen: 'Alta, visat i renovació. I t\'avisem nosaltres quan s\'acosti el termini.',
        entradilla: '',
        guionH2: [
          'MDP i MDL: quina autorització et correspon',
          'Requisits per obtenir-la',
          'El visat: quan toca i què passa si se\'t passa',
          'Altes i baixes de vehicles a l\'autorització',
          'Nosaltres portem el control dels teus venciments'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['capacitacion-transportista-tarragona', 'renovacion-tarjeta-transporte-tarragona'],
        ctaTitulo: 'Necessites la targeta de transport?',
        ctaTexto: 'Explica\'ns quins vehicles tens i et diem quina autorització et correspon.',
        ctaWhatsapp: 'Hola, necessito informació sobre la targeta de transport'
      }
    },

    {
      slug: { es: 'renovacion-tarjeta-transporte-tarragona', ca: 'renovacio-targeta-transport-tarragona' },
      grupo: 'autorizaciones',
      icono: 'mdi-calendar-refresh-outline',
      publicada: false,
      es: {
        titleSeo: 'Renovar la tarjeta de transporte en Tarragona | Gestoría Riola',
        description:
          'Visado y renovación de la tarjeta de transporte en Tarragona. Te avisamos antes del plazo y lo tramitamos sin que tengas que estar pendiente.',
        h1: 'Renovar la tarjeta de transporte en Tarragona',
        kwPrincipal: 'renovar tarjeta de transporte Tarragona',
        kwLongTail: [
          'visado tarjeta transporte plazo Tarragona',
          'se me ha pasado el visado de la tarjeta de transporte',
          'renovación autorización de transporte Cataluña'
        ],
        resumen: 'El visado tiene una ventana estrecha. Nosotros te avisamos antes de que se cierre.',
        entradilla: '',
        guionH2: [
          'Cuándo toca el visado según tu número de autorización',
          'Requisitos que hay que seguir cumpliendo',
          'Qué pasa si se te pasa el plazo',
          'Cómo lo llevamos nosotros: aviso previo y tramitación'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tarjeta-transporte-tarragona', 'capacitacion-transportista-tarragona'],
        ctaTitulo: '¿Sabes cuándo te toca visar?',
        ctaTexto: 'Mándanos tu número de autorización y te lo miramos.',
        ctaWhatsapp: 'Hola, quiero renovar mi tarjeta de transporte'
      },
      ca: {
        titleSeo: 'Renovar la targeta de transport a Tarragona | Gestoria Riola',
        description:
          'Visat i renovació de la targeta de transport a Tarragona. T\'avisem abans del termini i ho tramitem sense que hagis d\'estar pendent.',
        h1: 'Renovar la targeta de transport a Tarragona',
        kwPrincipal: 'renovar targeta de transport Tarragona',
        kwLongTail: [
          'visat targeta transport termini Tarragona',
          'se m\'ha passat el visat de la targeta de transport'
        ],
        resumen: 'El visat té una finestra estreta. Nosaltres t\'avisem abans que es tanqui.',
        entradilla: '',
        guionH2: [
          'Quan toca el visat segons el teu número d\'autorització',
          'Requisits que cal seguir complint',
          'Què passa si se\'t passa el termini',
          'Com ho portem nosaltres: avís previ i tramitació'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tarjeta-transporte-tarragona', 'capacitacion-transportista-tarragona'],
        ctaTitulo: 'Saps quan et toca visar?',
        ctaTexto: 'Envia\'ns el teu número d\'autorització i t\'ho mirem.',
        ctaWhatsapp: 'Hola, vull renovar la meva targeta de transport'
      }
    },

    {
      slug: { es: 'capacitacion-transportista-tarragona', ca: 'capacitacio-transportista-tarragona' },
      grupo: 'autorizaciones',
      icono: 'mdi-certificate-outline',
      publicada: false,
      es: {
        titleSeo: 'Capacitación profesional de transportista en Tarragona | Gestoría Riola',
        description:
          'Tramitamos tu título de capacitación profesional de transportista en Tarragona y el alta de la autorización. Te decimos los requisitos exactos.',
        h1: 'Capacitación profesional de transportista en Tarragona',
        kwPrincipal: 'capacitación transportista Tarragona',
        kwLongTail: [
          'título de capacitación profesional transporte Tarragona',
          'competencia profesional transportista Cataluña',
          'requisitos para ser transportista autónomo Tarragona'
        ],
        resumen: 'El título que necesitas para poder tener autorización de transporte a tu nombre.',
        entradilla: '',
        guionH2: [
          'Qué es y por qué la necesitas',
          'Cómo se obtiene: examen y convalidaciones',
          'Del título a la autorización de transporte',
          'Requisitos de capacidad financiera y honorabilidad'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tarjeta-transporte-tarragona', 'alta-autonomo-transportista-tarragona'],
        ctaTitulo: '¿Quieres montarte por tu cuenta?',
        ctaTexto: 'Te explicamos el camino completo, del título a la primera tarjeta.',
        ctaWhatsapp: 'Hola, quiero información sobre la capacitación de transportista'
      },
      ca: {
        titleSeo: 'Capacitació professional de transportista a Tarragona | Gestoria Riola',
        description:
          'Tramitem el teu títol de capacitació professional de transportista a Tarragona i l\'alta de l\'autorització. Et diem els requisits exactes.',
        h1: 'Capacitació professional de transportista a Tarragona',
        kwPrincipal: 'capacitació transportista Tarragona',
        kwLongTail: [
          'títol de capacitació professional transport Tarragona',
          'competència professional transportista Catalunya'
        ],
        resumen: 'El títol que necessites per poder tenir autorització de transport al teu nom.',
        entradilla: '',
        guionH2: [
          'Què és i per què la necessites',
          'Com s\'obté: examen i convalidacions',
          'Del títol a l\'autorització de transport',
          'Requisits de capacitat financera i honorabilitat'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tarjeta-transporte-tarragona', 'alta-autonomo-transportista-tarragona'],
        ctaTitulo: 'Vols muntar-te pel teu compte?',
        ctaTexto: 'T\'expliquem el camí complet, del títol a la primera targeta.',
        ctaWhatsapp: 'Hola, vull informació sobre la capacitació de transportista'
      }
    },

    {
      slug: { es: 'cap-conductores-tarragona', ca: 'cap-conductors-tarragona' },
      grupo: 'conductores',
      icono: 'mdi-account-tie-hat-outline',
      publicada: false,
      es: {
        titleSeo: 'CAP de conductores en Tarragona | Gestoría Riola',
        description:
          'Obtención y renovación del CAP en Tarragona. Caduca cada cinco años y sin él no puedes conducir profesionalmente. Te avisamos antes del vencimiento.',
        h1: 'CAP de conductores en Tarragona',
        kwPrincipal: 'CAP conductores Tarragona',
        kwLongTail: [
          'renovar CAP Tarragona',
          'CAP caducado qué hacer',
          'curso CAP continua Tarragona',
          'tarjeta de cualificación del conductor Tarragona'
        ],
        resumen: 'Caduca cada cinco años. Si se te pasa, no puedes conducir profesionalmente.',
        entradilla: '',
        guionH2: [
          'Qué es el CAP y quién está obligado',
          'CAP inicial y formación continua',
          'La tarjeta de cualificación del conductor',
          'Qué pasa si conduces con el CAP caducado',
          'Cuándo empezar a renovarlo'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tacografo-tarragona', 'capacitacion-transportista-tarragona'],
        ctaTitulo: '¿Cuándo te caduca el CAP?',
        ctaTexto: 'Dinos la fecha y te avisamos con tiempo para renovarlo.',
        ctaWhatsapp: 'Hola, necesito información sobre el CAP'
      },
      ca: {
        titleSeo: 'CAP de conductors a Tarragona | Gestoria Riola',
        description:
          'Obtenció i renovació del CAP a Tarragona. Caduca cada cinc anys i sense ell no pots conduir professionalment. T\'avisem abans del venciment.',
        h1: 'CAP de conductors a Tarragona',
        kwPrincipal: 'CAP conductors Tarragona',
        kwLongTail: [
          'renovar CAP Tarragona',
          'CAP caducat què fer',
          'curs CAP contínua Tarragona'
        ],
        resumen: 'Caduca cada cinc anys. Si se\'t passa, no pots conduir professionalment.',
        entradilla: '',
        guionH2: [
          'Què és el CAP i qui hi està obligat',
          'CAP inicial i formació contínua',
          'La targeta de qualificació del conductor',
          'Què passa si condueixes amb el CAP caducat',
          'Quan començar a renovar-lo'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['tacografo-tarragona', 'capacitacion-transportista-tarragona'],
        ctaTitulo: 'Quan et caduca el CAP?',
        ctaTexto: 'Digues-nos la data i t\'avisem amb temps per renovar-lo.',
        ctaWhatsapp: 'Hola, necessito informació sobre el CAP'
      }
    },

    {
      slug: { es: 'tacografo-tarragona', ca: 'tacograf-tarragona' },
      grupo: 'conductores',
      icono: 'mdi-gauge',
      publicada: false,
      es: {
        titleSeo: 'Tarjeta de tacógrafo en Tarragona | Gestoría Riola',
        description:
          'Tarjeta de tacógrafo digital para conductor, empresa o centro de ensayo en Tarragona. Primera expedición, renovación y sustitución por pérdida.',
        h1: 'Tarjeta de tacógrafo en Tarragona',
        kwPrincipal: 'tarjeta de tacógrafo Tarragona',
        kwLongTail: [
          'renovar tarjeta de tacógrafo Tarragona',
          'tarjeta tacógrafo digital conductor Tarragona',
          'he perdido la tarjeta del tacógrafo'
        ],
        resumen: 'De conductor o de empresa. Primera expedición, renovación y sustitución.',
        entradilla: '',
        guionH2: [
          'Tipos de tarjeta: conductor, empresa, taller y control',
          'Primera expedición y renovación',
          'Pérdida, robo o mal funcionamiento',
          'Plazos y qué hacer mientras esperas la nueva'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['cap-conductores-tarragona', 'tarjeta-transporte-tarragona'],
        ctaTitulo: '¿Necesitas la tarjeta de tacógrafo?',
        ctaTexto: 'Te decimos qué tipo te corresponde y la tramitamos.',
        ctaWhatsapp: 'Hola, necesito la tarjeta de tacógrafo'
      },
      ca: {
        titleSeo: 'Targeta de tacògraf a Tarragona | Gestoria Riola',
        description:
          'Targeta de tacògraf digital per a conductor, empresa o centre d\'assaig a Tarragona. Primera expedició, renovació i substitució per pèrdua.',
        h1: 'Targeta de tacògraf a Tarragona',
        kwPrincipal: 'targeta de tacògraf Tarragona',
        kwLongTail: [
          'renovar targeta de tacògraf Tarragona',
          'targeta tacògraf digital conductor Tarragona'
        ],
        resumen: 'De conductor o d\'empresa. Primera expedició, renovació i substitució.',
        entradilla: '',
        guionH2: [
          'Tipus de targeta: conductor, empresa, taller i control',
          'Primera expedició i renovació',
          'Pèrdua, robatori o mal funcionament',
          'Terminis i què fer mentre esperes la nova'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['cap-conductores-tarragona', 'tarjeta-transporte-tarragona'],
        ctaTitulo: 'Necessites la targeta de tacògraf?',
        ctaTexto: 'Et diem quin tipus et correspon i la tramitem.',
        ctaWhatsapp: 'Hola, necessito la targeta de tacògraf'
      }
    },

    {
      slug: { es: 'alta-autonomo-transportista-tarragona', ca: 'alta-autonom-transportista-tarragona' },
      grupo: 'autorizaciones',
      icono: 'mdi-account-plus-outline',
      publicada: false,
      es: {
        titleSeo: 'Darse de alta como transportista autónomo en Tarragona | Gestoría Riola',
        description:
          'Todo lo que necesitas para empezar como transportista autónomo en Tarragona: capacitación, autorización, alta en Hacienda y Seguridad Social.',
        h1: 'Darse de alta como transportista autónomo en Tarragona',
        kwPrincipal: 'alta transportista autónomo Tarragona',
        kwLongTail: [
          'requisitos para ser transportista autónomo Tarragona',
          'darse de alta como transportista Cataluña',
          'qué necesito para empezar en el transporte'
        ],
        resumen: 'El camino completo para empezar: capacitación, autorización y altas.',
        entradilla: '',
        guionH2: [
          'El orden correcto de los trámites',
          'Capacitación profesional y honorabilidad',
          'Capacidad financiera: cuánto te van a pedir',
          'La autorización de transporte y el primer vehículo',
          'Los seguros que vas a necesitar desde el primer día'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['capacitacion-transportista-tarragona', 'tarjeta-transporte-tarragona'],
        ctaTitulo: '¿Empiezas en el transporte?',
        ctaTexto: 'Te hacemos el mapa completo de trámites según tu situación.',
        ctaWhatsapp: 'Hola, quiero darme de alta como transportista autónomo'
      },
      ca: {
        titleSeo: 'Donar-se d\'alta com a transportista autònom a Tarragona | Gestoria Riola',
        description:
          'Tot el que necessites per començar com a transportista autònom a Tarragona: capacitació, autorització, alta a Hisenda i Seguretat Social.',
        h1: 'Donar-se d\'alta com a transportista autònom a Tarragona',
        kwPrincipal: 'alta transportista autònom Tarragona',
        kwLongTail: [
          'requisits per ser transportista autònom Tarragona',
          'donar-se d\'alta com a transportista Catalunya'
        ],
        resumen: 'El camí complet per començar: capacitació, autorització i altes.',
        entradilla: '',
        guionH2: [
          'L\'ordre correcte dels tràmits',
          'Capacitació professional i honorabilitat',
          'Capacitat financera: quant et demanaran',
          'L\'autorització de transport i el primer vehicle',
          'Les assegurances que necessitaràs des del primer dia'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['capacitacion-transportista-tarragona', 'tarjeta-transporte-tarragona'],
        ctaTitulo: 'Comences en el transport?',
        ctaTexto: 'Et fem el mapa complet de tràmits segons la teva situació.',
        ctaWhatsapp: 'Hola, vull donar-me d\'alta com a transportista autònom'
      }
    }
  ]
};
